import { VideoSourceDropdownOption } from "./video-source-dropdown.types";

export const itemTemplate = (option: VideoSourceDropdownOption) => {
	return <div>{option.label}</div>;
};
